import * as algolia from '@boutique/algolia'
import * as cold from '@owl-nest/cold-data/client'
import * as entities from '@boutique/entities'
import * as base from './base'

export async function searchProduct({
  facetFilters: faceFilters,
  sort,
  page,
  hitsPerPage,
  fullTextSearch,
  searchableTag,
  priceRange,
  showHidden = false,
  filters = [],
  hierarchy,
}: entities.search.product.Query): Promise<entities.search.product.Result> {
  const simpleFilters: (string | string[])[] = ['availableForSale:true']
  if (!showHidden) {
    simpleFilters.push('NOT tags:hidden')
  }
  if (filters) {
    simpleFilters.push(...filters)
  }

  const facets = base.facets<entities.search.product.Filters>(faceFilters, entities.search.product.FILTERS, {
    sizes: (value) => {
      return [{ value }]
    },
    colors: (value) => {
      return [{ value }]
    },
    category: (value) => {
      if (cold.types['category'].includes(value)) {
        const tags = cold.taxonomies[value]
        return [{ value: tags.children.tags[0], excluded: true }]
      }
      return []
    },
    brands: (value) => {
      const brands = value.reduce((brands, brandSlug) => {
        const brand = cold.brands[brandSlug]
        if (brand?.identifier) {
          brands.push(brand.identifier)
        }
        return brands
      }, [] as string[])

      return [{ value: brands }]
    },
    deal: (value) => {
      return [{ value }]
    },
    environmentalPillars: (value) => {
      const environmentalPillars = value.filter((pillar) => {
        return cold.taxonomies[cold.types['environmental-pillar']].children.tags.includes(pillar)
      })

      return [{ value: environmentalPillars }]
    },
    socialPillars: (value) => {
      const socialPillars = value.filter((pillar) => {
        return cold.taxonomies[cold.types['social-pillar']].children.tags.includes(pillar)
      })

      return [{ value: socialPillars }]
    },
    types: (value) => {
      return [{ value }]
    },
    genders: (value) => {
      return [{ value }]
    },
  })

  const response = await algolia.product.search({
    sortIndex: sort,
    fullTextSearch: fullTextSearch ?? searchableTag,
    filters: simpleFilters,
    priceRange,
    page,
    hitsPerPage,
    facets,
    hardFilters: hardFilters(hierarchy),
  })

  return base.toSearchResult<entities.search.product.Filters>(response, facets, entities.search.product.FILTERS)
}

function hardFilters(hierarchy?: string): algolia.product.Facet[] {
  if (hierarchy === undefined) {
    return []
  }

  const path = cold.hierarchy.index[hierarchy]
  const tags = new Set<string>()

  let current = cold.hierarchy.tree
  for (const index of path) {
    current = current.children[index]
    current.tags.forEach((tag) => tags.add(tag))
  }

  return [{ attribute: 'tags', value: Array.from(tags) }]
}
